/**
 *
 * Created by jlado on 25/8/16.
 */
export class Font {
    name:string;
    style:string;

    constructor(name?:string, style?:string) {
        this.name = name;
        this.style = style;
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/common/Font.ts
 **/